<template>
  <div class="row">
    <div v-for="item in cardData" :key="item.id" class="col-sm-6 col-xl-4 mb-5">
      <div class="card h-100">
        <div class="crop crop-16by9">
          <img
            class="crop-content crop-content-center card-img-top"
            :alt="item.acf.image.alt"
            :src="item.acf.image.url"
          />
        </div>
        <div class="card-body">
          <h3 class="card-title h5">{{ item.title.rendered }}</h3>
          <p class="card-text" v-html="item.acf.body"></p>
        </div>
        <div class="card-footer p-0 bg-gray-alabaster">
          <a
            class="btn btn-chevron-right text-body-link d-flex justify-content-between align-items-center font-weight-bold py-3 pl-3 pr-2 w-100 text-left"
            :href="item.acf.url"
            target="_self"
          >
            <span>{{ item.acf.urltext }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import cookies from "vue-cookies";
export default {
  props:["url"],
  data() {
    let contract_type = {
      elnat: cookies.get("pfu_elnat"),
      elhandel: cookies.get("pfu_elhandel"),
      omt_status: cookies.get("pfu_omteckningstatus"),
      fjv: cookies.get("pfu_fjarrvarme"),
      bb: cookies.get("pfu_bredband"),
      tv: cookies.get("pfu_tv"),
      typ1: cookies.get("pfu_avtal").indexOf(1) != -1 ? "true" : "false",
      typ2: cookies.get("pfu_avtal").indexOf(2) != -1 ? "true" : "false",
      typ3: cookies.get("pfu_avtal").indexOf(3) != -1 ? "true" : "false",
      typ4: cookies.get("pfu_avtal").indexOf(4) != -1 ? "true" : "false",
      typ5: cookies.get("pfu_avtal").indexOf(5) != -1 ? "true" : "false",
      typ6: cookies.get("pfu_avtal").indexOf(6) != -1 ? "true" : "false"
    };

    console.log(contract_type);
    return {
      pp: cookies.get("pfu_privateperson"),
      contract_type,
      cardData: [],
    };
  },

  methods: {
    fetchCards() {
      fetch(this.url + "/wp-json/wp/v2/cards")
        .then((response) => response.json())
        .then((data) =>
          data.sort(function (a, b) {
            return a.menu_order - b.menu_order;
          })
        )
        .then(
          (sortedData) => (this.cardData = sortedData.filter(this.filterData))
        )
    },

    filterData(item) {
      let temp = false;
      let audience = item.acf.audience;

      //3 = alla, 2 = företag, 1 = privatkund. pp = true om privatkund. 

      if (audience == "3" || (audience == "1" && this.pp == "true") || (audience == "2" && this.pp == "false") ) {
     
        // Loopar contract_type på varje puff, som avgör vilka avtal kund behöver för att se puff.
        
        item.acf.contract_type.map((ct) => {
          if (ct == "omt_status") {
            if (this.contract_type[ct] == 1 || this.contract_type[ct] == 2) {
              temp = true;
            }
          } else if (this.contract_type[ct] == "true") {
            temp = true;
          }
        });
      }

      return temp;
    },
  },
  mounted() {
    this.fetchCards();
  },
};
</script>
